// Product image & video assets — served locally from /public for same-origin
// reliability on the custom domain (sapeur-360.fr). Sapeur-360 by KRX.
export const ASSETS = {
  logo: "/images/logo.jpg?v=2",
  product: "/images/product.jpg",
  fireSuppression: "/images/fire_suppression.jpg",
  underVehicle: "/images/under_vehicle_clean.jpg",
  logistique: "/images/logistique.jpg?v=3",
  carFire: "/images/car_fire.jpg",
  liftCar: "/images/lift_car.jpg",
};

export const VIDEOS = [
  {
    src: "/videos/levage_deplacement.mp4?v=2",
    title: "Levage & déplacement",
    desc: "La plateforme se glisse sous le véhicule, le soulève et le déplace au centimètre près.",
  },
  {
    src: "/videos/extinction.mp4",
    title: "Extinction d'un feu de véhicule",
    desc: "Projection d'eau ciblée pour maîtriser l'incendie, y compris sur batteries électriques.",
  },
  {
    src: "/videos/logistique.mp4?v=2",
    poster: "/images/logistique.jpg?v=3",
    title: "Logistique & charges délicates",
    desc: "Transport d'une charge palettisée et sanglée : la plateforme la déplace en douceur, du véhicule de livraison jusqu'au hall.",
  },
];
